import { ICliente } from './icliente';

export interface IDepartamento {
  DepartamentoNo: number;
  ClienteNo: number;
  DepartamentoNome: string;
  blAdm: boolean;
  ClienteNoExterno: ICliente;
}
